// React Component
import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

// App Component
import { Buttons, InputForm } from '../../components'
import { Routes } from '../../routes'
import { FamlaServices } from '../../services'
import { login, useAppDispatch, useAppSelector } from '../../stores'
import { Metrics } from '../../constants'
import { useTranslation } from 'react-i18next'
import { useTheme } from '../../contexts/ThemeContext'
import { getMarketplaceToken, shouldResumeMarketplaceFlow } from '../../utils/marketplaceSession'
import { startAdminOnboarding } from '../../utils/adminOnboardingStorage'

//interface
import { iAlert } from '../../interfaces'
import { iSessions } from '../auth'

// [DOMAINES EMAIL PRIVÉS] Liste domaines B2C exclus du pré-remplissage automatique
const PRIVATE_DOMAINS = new Set([
    "gmail.com", "googlemail.com", "hotmail.com", "outlook.com",
    "live.com", "yahoo.com", "yahoo.fr", "icloud.com", "me.com",
    "msn.com", "aol.com", "protonmail.com", "pm.me", "yandex.com",
    "gmx.com", "gmx.net", "gmx.fr", "mail.com", "zoho.com",
    "tutanota.com", "fastmail.com", "qq.com", "163.com", "126.com",
    "mail.ru", "ymail.com", "rocketmail.com",
    "orange.fr", "free.fr", "laposte.net", "sfr.fr", "wanadoo.fr",
    "libero.it", "virgilio.it", "alice.it", "tin.it",
    "web.de", "posteo.de", "t-online.de",
    "btinternet.com", "sky.com", "virginmedia.com",
    "comcast.net", "verizon.net", "att.net", "cox.net",
]);

const CompanyCreate = () => {
    const users = useAppSelector((state) => state.auth);
    const dispatch = useAppDispatch();
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { theme } = useTheme()
    const inputSurfaceClass =
        theme === 'light' ? 'bg-white text-dark border' : 'bg-dark text-light text-bg-dark'
    const [company, setCompany] = React.useState({
        name: '',
        adress: '',
        city: '',
        country: '',
        postalCode: "",
        website: "",
        phoneNumber: "",
        promoCode: "",
        isCollaborator: true,
        isSubmit: false,
        myRole: ''
    });
    // console.log("user", users);

    // const [city, setcity] = React.useState<city[]>([])
    // const sortedcity = city.sort((a, b) => a.name.localeCompare(b.name));
    // const selectcityOptions = sortedcity.map((city) => ({
    //     label: city.name,
    //     value: city.name,
    // }));


    const [alert, setAlert] = React.useState<iAlert>({
        isActive: false,
        type: '',
        message: ''
    })

    React.useEffect(() => {
        // [PRÉ-REMPLISSAGE] Suggérer nom/website à partir du domaine email professionnel
        const email = users?.session?.user?.email || "";
        const domain = email.includes("@") ? email.split("@")[1]?.toLowerCase() : "";
        if (domain && !PRIVATE_DOMAINS.has(domain)) {
            const suggested = domain.split(".")[0];
            setCompany((prev) => ({
                ...prev,
                name: prev.name || suggested.charAt(0).toUpperCase() + suggested.slice(1).replace(/-/g, " ").replace(/_/g, " "),
                website: prev.website || `https://${domain}`,
            }));
        }

        const getMyRole = async () => {
            let data = await FamlaServices("api_host", `/users/my/role`, "GET", "", users.access_token);
            if (data.status === 200) {
                setCompany((prev) => ({ ...prev, myRole: data.body.data }))
            }
        }

        getMyRole()

    }, [users.access_token, users?.session?.user?.email])

    const handleChange = (event: any) => {
        const { type, name, value, checked } = event.target;
        let fieldValue = type === 'checkbox' ? checked : value;

        if (type === 'number') {
            fieldValue = Number(fieldValue);
        }
        if (name === 'name') {
            setCompany({ ...company, name: fieldValue })
        } else if (name === 'adress') {
            setCompany({ ...company, adress: fieldValue })
        } else if (name === 'city') {
            setCompany({ ...company, city: fieldValue })
        } else if (name === 'country') {
            setCompany({ ...company, country: fieldValue })
        } else if (name === 'postalcode') {
            setCompany({ ...company, postalCode: fieldValue })
        } else if (name === 'website') {
            setCompany({ ...company, website: fieldValue })
        } else if (name === 'number') {
            setCompany({ ...company, phoneNumber: fieldValue })
        } else if (name === 'promoCode') {
            setCompany({ ...company, promoCode: fieldValue.toUpperCase() })
        }
    };

    const handleSubmit = async (event: React.SyntheticEvent) => {
        event.preventDefault();

        if (company.name.trim().length === 0) {
            setAlert({ isActive: true, type: 'danger', message: 'Company name is required' });
            return;
        } else if (company.city.trim().length === 0) {
            setAlert({ isActive: true, type: 'danger', message: 'City is required' });
            return;
        } else if (company.adress.trim().length === 0) {
            setAlert({ isActive: true, type: 'danger', message: 'Address is required' });
            return;
        } else if (company.country.trim().length === 0) {
            setAlert({ isActive: true, type: 'danger', message: 'Country is required' });
            return;
        }


        let formData: any = {
            name: company.name,
            address: company.adress,
            city: company.city,
            postal_code: company.postalCode,
            country: company.country,
            website: company.website
        }
        // Inclure le numéro de téléphone uniquement s'il est renseigné
        if (company.phoneNumber && company.phoneNumber.trim().length > 0) {
            formData.phone_number = company.phoneNumber.trim();
        }
        
        // Ajouter le code promo si fourni
        if (company.promoCode && company.promoCode.trim().length > 0) {
            formData.promo_code = company.promoCode.trim().toUpperCase();
        }

        setCompany({ ...company, isSubmit: true });

        let data = await FamlaServices("api_host", `/company/`, "POST", formData, users.access_token);

        if (data.status === 201) {
            setCompany((prevState) => ({ ...prevState, name: '', adress: '', city: "", postalCode: "", country: "", website: "", phoneNumber: "", promoCode: "", isSubmit: false }));
            let sessions: iSessions = data.body.data;
            dispatch(login({ token: users.access_token, session: sessions, user: sessions.user }));
            
            const marketplaceToken = shouldResumeMarketplaceFlow() ? getMarketplaceToken() : null;
            if (marketplaceToken) {
                navigate(
                    `/microsoft-purchase?token=${encodeURIComponent(marketplaceToken)}`,
                    { replace: true },
                );
                return;
            }

            // [INVITATION PROCESSUS] Vérifier si l'utilisateur a une invitation en cours
            const invitedProcessId = sessionStorage.getItem('invited_process_id');
            const invitationToken = sessionStorage.getItem('invitation_token');
            if (invitedProcessId) {
                // Rediriger vers le processus invité après création de company
                console.log('🔗 [CreateMyCompany] Company created, redirecting to invited process:', invitedProcessId);
                console.log('🔗 [CreateMyCompany] Invitation token preserved:', { hasToken: !!invitationToken });
                // NE PAS nettoyer sessionStorage ici - laisser AuthGuard le faire après redirection réussie
                navigate(`${Routes.PROCESS_INTERVIEW}${invitedProcessId}`, { replace: true });
            } else {
                // Nouveau créateur de compagnie : onboarding avant le funnel
                // invitation d'équipe → questionnaire de provenance.
                startAdminOnboarding();
                navigate(Routes.COMPANY_ONBOARDING, { replace: true });
            }

        } else if (data.status === 401) {
            setAlert({ isActive: true, type: 'danger', message: t('navigation.youAreNotLoggedIn') });
        } else if (data.status === 400) {
            // Erreur de validation (ex: code promo invalide)
            const errorMessage = data.body?.description || data.body?.message || t('navigation.anErrorOcured');
            setAlert({ isActive: true, type: 'danger', message: errorMessage });
        }
        else {
            setAlert({ isActive: true, type: 'danger', message: t('navigation.anErrorOcured') });
        }
        setCompany({ ...company, isSubmit: false });
    };


    return (
        <div className="w-50" style={{ margin: "auto" }}>
            <div className="mb-5" style={{ marginTop: "20%" }}>
                {/* <Link to={Routes.HOMEVIEW} className="text-light fw-bold fs-3 text-decoration-none">
                    <i className="fa-solid fa-arrow-left "></i>  
                    {t('form.createCompany.createACompany')}
                </Link> */}
                <h1 className={`fw-bold fs-3 mb-0 ${theme === 'light' ? 'text-dark' : 'text-light'}`}>
                    {t('form.createCompany.createACompany')}
                </h1>
            </div>

            <div className="mt-4 pb-5 overflow-auto">
                <span className='text-theme'>{t('navigation.allFieldsRequired')}</span>
                <InputForm
                    inputType="text"
                    inputLabel={t('form.createCompany.companyName') + ' *'}
                    inputName="name"
                    inputValue={company.name}
                    isFloatingLabel={true}
                    labelClass="text-theme"
                    onChange={(e) => handleChange(e)}
                    inputContainerClass={'mb-3'}
                    inputClass={inputSurfaceClass}
                />

                <InputForm
                    inputType="text"
                    inputLabel={t('words.address') + ' *'}
                    inputName="adress"
                    inputValue={company.adress}
                    isFloatingLabel={true}
                    labelClass="text-theme"
                    onChange={(e) => handleChange(e)}
                    inputContainerClass={'mb-3'}
                    inputClass={inputSurfaceClass}
                />
                <InputForm
                    inputType="text"
                    inputLabel={t('words.city') + ' *'}
                    inputName="city"
                    inputValue={company.city}
                    isFloatingLabel={true}
                    labelClass="text-theme"
                    onChange={(e) => handleChange(e)}
                    inputContainerClass={'mb-3'}
                    inputClass={inputSurfaceClass}
                />
                <InputForm
                    inputType="text"
                    inputLabel={t('form.createCompany.postalCode') + ' *'}
                    inputName="postalcode"
                    inputValue={company.postalCode}
                    isFloatingLabel={true}
                    labelClass="text-theme"
                    onChange={(e) => handleChange(e)}
                    inputContainerClass={'mb-3'}
                    inputClass={inputSurfaceClass}
                />
                <InputForm
                    inputType="text"
                    inputLabel={t('words.country') + ' *'}
                    inputName="country"
                    inputValue={company.country}
                    isFloatingLabel={true}
                    labelClass="text-theme"
                    onChange={(e) => handleChange(e)}
                    inputContainerClass={'mb-3'}
                    inputClass={inputSurfaceClass}
                />
                <InputForm
                    inputType="text"
                    inputLabel={t('form.createCompany.website')}
                    inputName="website"
                    inputValue={company.website}
                    isFloatingLabel={true}
                    labelClass="text-theme"
                    onChange={(e) => handleChange(e)}
                    inputContainerClass={'mb-3'}
                    inputClass={inputSurfaceClass}
                />
                <InputForm
                    inputType="text"
                    inputLabel={t('form.createCompany.phoneNumber')}
                    inputName="number"
                    inputValue={company.phoneNumber}
                    isFloatingLabel={true}
                    labelClass="text-theme"
                    onChange={(e) => handleChange(e)}
                    inputContainerClass={'mb-3'}
                    inputClass={inputSurfaceClass}
                />
                
                <InputForm
                    inputType="text"
                    inputLabel={t('form.createCompany.promoCode') || "Code Promo"}
                    inputName="promoCode"
                    inputValue={company.promoCode}
                    isFloatingLabel={true}
                    labelClass="text-theme"
                    onChange={(e) => handleChange(e)}
                    inputContainerClass={'mb-3'}
                    inputClass={inputSurfaceClass}
                    placeholderValue={t('form.createCompany.promoCodePlaceholder') || "Ex: GenAI.works"}
                />

                {/* <SelectForm
                    selectClass="mb-3"
                    placeholder="Select city"
                    selectName='selectName'
                    selectOptions={selectcityOptions}
                    onChange={(e) => handleChange(e)}
                /> */}


                {alert.isActive &&
                    <div className={`alert alert-${alert.type}`} role="alert">
                        {alert.message}
                    </div>
                }
                <Buttons
                    buttonType="submit"
                    name={t('words.create')}
                    onClick={(e) => { handleSubmit(e) }}
                    isLoading={company.isSubmit}
                    btnClass="btn-theme mt-5 w-100"
                    labelClass="text-white fw-bold fs-5"
                    btnStyle={{ height: 68 }}
                    arrowVisible={true}
                    arrowColor='text-white'
                    disabled={company.name.length === 0 || company.adress.length === 0 || company.city.length === 0 || company.country.length === 0 ? true : false}
                />
            </div>
        </div>
    )
}

export default CompanyCreate